import { combineReducers } from "redux";
import { ICompanyState } from "./company/company.interface";
import { companyReducer } from "./company/company.reducer";
import { IUserState } from "./user/user.interface";
import { userReducer } from "./user/user.reducer";

export interface IRootReducer{
  user: IUserState;
  company: ICompanyState;
}

const rootReducer = combineReducers<IRootReducer>({
  user: userReducer,
  company: companyReducer,
});

export default rootReducer;

